import { SEBS_COMPOSER_KEYBOARD_EXPERIMENT } from '~/constants/composer';
import {
  useComposerAssignedBucket,
  useComposerExperiments
} from '~/context/composer/ComposerContext';
import useTrackRendered from './useTrackRendered';

// Gated on the Frontier bucket, not showComposerTreatment, which flips on revert.
export default function useTrackComposerKeyboardRendered() {
  const frontierBucket = useComposerAssignedBucket();
  const keyboardBucket =
    useComposerExperiments()[SEBS_COMPOSER_KEYBOARD_EXPERIMENT];

  useTrackRendered(
    SEBS_COMPOSER_KEYBOARD_EXPERIMENT,
    frontierBucket === 'treatment',
    undefined,
    keyboardBucket
  );
}
